import Warns from './index.vue'

Warns.install = Vue => {
  Vue.component(Warns.name, Warns)
}

export default Warns



// WEBPACK FOOTER //
// ./src/components/warns/index.js